module.exports = __webpack_public_path__ + "img/settings_320.7078538a.png";